/* 🤖 this file was generated by svg-to-ts */
export const matIconAddToPhotos: {
  name: 'add-to-photos';
  data: string;
} = {
  name: 'add-to-photos',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zm-7-1h2v-4h4V9h-4V5h-2v4H9v2h4z"/></svg>`
};
